export default __webpack_public_path__ + "static/Specialities-c9319454f3acedbe8c3c52c263091b4b.png";